import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomTableModule } from '../../../../shared/modules/custom-table/custom-table.module';
import { CustomAvailabilityTableHeaderComponent } from './custom-date-table-header/custom-availability-table-header.component';

@NgModule({
  declarations: [CustomAvailabilityTableHeaderComponent],
  exports: [CustomAvailabilityTableHeaderComponent],
  imports: [CommonModule, CustomTableModule, MatTooltipModule],
})
export class CustomAvailabilityTableModule {}
